import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Vacancy {
  id: number;
  title: string;
  text_message: string;
  country: string;
  city: string;
  vacancy: string;
  salary: string;
  work_schedule: string;
  documents: string;
  home: string;
  job_description: string;
}
export class VacanciesService {
  index;
vacancies: Vacancy[] = [
{
  id: 1 ,
  title: 'LG - ТЕЛЕВІЗОРИ. КОМПЛЕКТУВАННЯ ДРІБНИХ ДЕТАЛЕЙ',
  country: 'ПОЛЬЩА',
  city: 'MLAWA',
  text_message: 'Tekст повідомлення. Tekст повідомлення. Tekст повідомлення. ',
  vacancy: 'Чоловіків, жінок, сімейних пар. Вік до 55 років',
  salary: '10.25 злотих год / нетто',
  work_schedule: 'ПН-СБ, 10-12год',
  documents: 'Робоча віза, або біометричний паспорт',
  home: 'Безкоштовне.Тільки 190 злотих в місяць за комунальні і довезення до місця роботи',
  job_description: 'Робота на конвеєрі. Полягає в комплектації дрібних елементів, складових до телевізорів. Робота стояча(не важка)'
},
{
  id: 2 ,
  title: 'LG - ТЕЛЕВІЗОРИ. КОМПЛЕКТУВАННЯ ДРІБНИХ ДЕТАЛЕЙ',
  country: 'ПОЛЬЩА',
  city: 'MLAWA',
  text_message: '',
  vacancy: 'Чоловіків, жінок, сімейних пар. Вік до 55 років',
  salary: '10.25 злотих год / нетто',
  work_schedule: 'ПН-СБ, 10-12год',
  documents: 'Робоча віза, або біометричний паспорт',
  home: 'Безкоштовне.Тільки 190 злотих в місяць за комунальні і довезення до місця роботи',
  job_description: 'Робота на конвеєрі. Полягає в комплектації дрібних елементів, складових до телевізорів. Робота стояча(не важка)'
},
{
  id: 3 ,
  title: 'LG - ТЕЛЕВІЗОРИ. КОМПЛЕКТУВАННЯ ДРІБНИХ ДЕТАЛЕЙ',
  country: 'ПОЛЬЩА',
  city: 'MLAWA',
  text_message: 'Tekст повідомлення-3. Tekст повідомлення-3. Tekст повідомлення-3.',
  vacancy: 'Чоловіків, жінок, сімейних пар. Вік до 55 років',
  salary: '10.25 злотих год / нетто',
  work_schedule: 'ПН-СБ, 10-12год',
  documents: 'Робоча віза, або біометричний паспорт',
  home: 'Безкоштовне.Тільки 190 злотих в місяць за комунальні і довезення до місця роботи',
  job_description: 'Робота на конвеєрі. Полягає в комплектації дрібних елементів, складових до телевізорів. Робота стояча(не важка)'
}
];
  constructor() { }

  getIndexVacancies() {
   return this.index = this.vacancies.length;
  }

   getVacancies(): Vacancy[] {
    return this.vacancies;
  }
}
